import "./FailedRuleDetails.css";
import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  getApproveORFailRules,
  viewCodeAssistRules,
} from "../TestRule/TestRuleRedux";

// Static mock data for now — swap for API call later using `ruleId`
const RULES_DATA = {
  "RUL-1042": {
    id: "RUL-1042",
    title: "High-Risk Pregnancy Aspirin Prophylaxis",
    description: "High-Risk Pregnancy Aspirin Prophylaxis",
    createdOn: "Oct 24, 2023",
    createdBy: "Zoe H",
    status: "Submitted for Testing",
    pathwayEntity: "OB/GYN Intake",
    triggerCodes: ["O09.89", "Z33.1"],
    configuredGuidance: "Consider Aspirin Prophylaxis for High-Risk Pregnancy.",
    recommendedAction: "Review and apply the recommended clinical guidance.",
    testStatus: "Failed",
    testedBy: "Zoe. H",
    testedOn: "Oct 26, 2023, 14:45 EST",
    failureReason:
      "The configured trigger code did not display the expected guidance in the application during verification.",
  },
};

const DEFAULT_RULE = RULES_DATA["RUL-1042"];

export default function FailedRuleDetails({ onRetest }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const ruleId = searchParams.get("code_assist_manual_rule_id");
  const ruleAction = searchParams.get("action");
  const ruleReason = searchParams.get("reason");
  const isViewPage = searchParams.get("isViewPage");

  // Static lookup for now — replace with API fetch later
  // const rule = (ruleId && RULES_DATA[ruleId]) || DEFAULT_RULE;

  const {
    loading: approveORFailRulesLoading,
    data: approveORFailRulesData,
    error: approveORFailRulesError,
  } = useSelector((state) => state.testRule.approveORFailRules);

  const {
    loading: viewCodeAssistRulesResponseLoading,
    data: viewCodeAssistRulesResponseData,
    error: viewCodeAssistRulesResponseError,
  } = useSelector((state) => state.testRule.viewCodeAssistRulesResponse);

  // failure_information
  const failedRuleDetailsMappingData = isViewPage
    ? viewCodeAssistRulesResponseData
    : approveORFailRulesData;
  const failedRuleDetailsLoader = isViewPage
    ? viewCodeAssistRulesResponseLoading
    : approveORFailRulesLoading;

  const statusText = !isViewPage
  ? approveORFailRulesData?.rule_information?.status || "-"
  : viewCodeAssistRulesResponseData?.status || "-";

  const handleBack = () => {
    navigate("/test-rule-table");
  };
  const handleEditRule = () => {
    console.log(failedRuleDetailsMappingData, 'failedRuleDetailsMappingData')
    const queryParams = new URLSearchParams({
                          code_assist_manual_rule_id: failedRuleDetailsMappingData?.code_assist_manual_rule_id,
                          isEditPage: false,
                        });
                        navigate(`/failed-rule-edit?${queryParams.toString()}`);
  };
  const handleRetestRule = () => {
    navigate(`/test-rule-table`);
  };

  useEffect(() => {
    if (!ruleId) return;

    const fetchRuleDetails = async () => {
      try {
        let result;

        if (isViewPage) {
          const payload = {
            code_assist_manual_rule_id: ruleId,
          };

          result = await dispatch(viewCodeAssistRules(payload)).unwrap();
        } else {
          if (!ruleAction) return;

          const payload = {
            code_assist_manual_rule_id: ruleId,
            action: ruleAction,
            reason: ruleReason || "",
          };

          result = await dispatch(getApproveORFailRules(payload)).unwrap();
        }

        console.log("Rule details:", result);
      } catch (error) {
        console.error("Failed to get rule details:", error);
      }
    };

    fetchRuleDetails();
  }, [dispatch, ruleId, ruleAction, ruleReason, isViewPage]);

  return (
    <div className="failedRule-page">
      {/* Header */}
      <div className="failedRule-header">
        <div className="failedRule-header-title-row">
          <h1 className="failedRule-title">
            {failedRuleDetailsLoader
              ? "Description..."
              : failedRuleDetailsMappingData?.description
                ? failedRuleDetailsMappingData?.description
                : "No Title"}
          </h1>
          <span className="failedRule-id-pill">
            {failedRuleDetailsLoader
              ? "Rule ID..."
              : failedRuleDetailsMappingData?.rule_id
                ? failedRuleDetailsMappingData?.rule_id
                : "No Rule ID"}
          </span>
          <span className="failedRule-status-badge failedRule-status-badge--failed">
            FAILED
          </span>
        </div>
        <div className="failedRule-header-actions">
          {/* <button
            type="button"
            className="failedRule-btn failedRule-btn--ghost"
            onClick={handleRetestRule}
          >
            <span className="failedRule-btn-icon" aria-hidden="true">
              &#8635;
            </span>
            Retest
          </button> */}
          <button
            type="button"
            className="failedRule-btn failedRule-btn--dark"
            onClick={handleEditRule}
          >
            Edit Rule
          </button>
        </div>
      </div>

      {/* Rule Information */}
      <section className="failedRule-card">
        <div className="failedRule-card-header">Rule Information</div>
        <div className="failedRule-card-body">
          <div className="failedRule-grid">
            <div className="failedRule-field">
              <div className="failedRule-label">Rule ID</div>
              <div className="failedRule-value">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : failedRuleDetailsMappingData?.rule_id
                    ? failedRuleDetailsMappingData?.rule_id
                    : "-"}
              </div>
            </div>
            <div className="failedRule-field">
              <div className="failedRule-label">Rule Description</div>
              <div className="failedRule-value">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : failedRuleDetailsMappingData?.description
                    ? failedRuleDetailsMappingData.description
                    : "-"}
              </div>
            </div>

            <div className="failedRule-field">
              <div className="failedRule-label">Created On</div>
              <div className="failedRule-value">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : failedRuleDetailsMappingData?.rule_information?.created_on
                    ? failedRuleDetailsMappingData?.rule_information?.created_on
                    : "-"}
              </div>
            </div>
            <div className="failedRule-field">
              <div className="failedRule-label">Created By</div>
              <div className="failedRule-value">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : failedRuleDetailsMappingData?.rule_information?.created_by
                    ? failedRuleDetailsMappingData?.rule_information?.created_by
                    : "-"}
              </div>
            </div>

            <div className="failedRule-field">
              <div className="failedRule-label">Status</div>
              <div className="failedRule-value">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : statusText}
              </div>
            </div>
            <div className="failedRule-field">
              <div className="failedRule-label">Pathway Entry Point</div>
              <div className="failedRule-value">
{failedRuleDetailsLoader ? "Loading..." : 
                <>
                <span>{failedRuleDetailsMappingData?.rule_configuration?.pathway_entry?.type}</span> /{" "}
                <span>{failedRuleDetailsMappingData?.rule_configuration?.pathway_entry?.value || ""}</span>
                </>
                }
              </div>
            </div>

            <div className="failedRule-field">
              <div className="failedRule-label">Trigger Codes</div>
              <div className="failedRule-tags">
                {failedRuleDetailsLoader ? (
                  "Loading..."
                ) : failedRuleDetailsMappingData?.rule_configuration
                    ?.trigger_codes?.length > 0 ? (failedRuleDetailsMappingData?.rule_configuration?.trigger_codes.map(
                    (item, index) => (
                      <span
                        className="ruleDetail-tag"
                        key={`${item?.code}-${index}`}
                      >
                        {item?.code || "No code"}
                      </span>
                    ),
                  )
                ) : (
                  <span className="ruleDetail-tag">No code</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Rule Configuration */}
      <section className="failedRule-card">
        <div className="failedRule-card-header">Rule Configuration</div>
        <div className="failedRule-card-body">
          <div className="failedRule-field">
            <div className="failedRule-label">Pathway Entry Point</div>
            <div className="failedRule-value">
          {
  failedRuleDetailsLoader
    ? "Loading..."
    : failedRuleDetailsMappingData?.rule_configuration?.pathway_entry?.type
      ? `${failedRuleDetailsMappingData.rule_configuration.pathway_entry.type} - ${
          failedRuleDetailsMappingData.rule_configuration.pathway_entry.value || ""
        }`
      : "-"
}
            </div>
          </div>

          <div className="failedRule-field failedRule-field--spaced">
            <div className="failedRule-label">Trigger Code(s)</div>
            <div className="failedRule-tags">
                {failedRuleDetailsLoader ? (
                "Loading..."
              ) : failedRuleDetailsMappingData?.rule_configuration?.trigger_codes
                  ?.length === 0 ? (
                <span className="viewActiveRule-value">No trigger codes.</span>
              ) : (
                failedRuleDetailsMappingData?.rule_configuration?.trigger_codes?.map(
                  (item) => (
                    <span className="viewActiveRule-tag" key={item.code}>
                      <span className="viewActiveRule-tag-code">
                        {item.code}
                      </span>
                      <span className="viewActiveRule-tag-desc">
                        {item.description}
                      </span>
                    </span>
                  ),
                )
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Guidance & Decision Support */}
      <section className="failedRule-card">
        <div className="failedRule-card-header">
          Guidance &amp; Decision Support
        </div>
        <div className="failedRule-card-body">
          <div className="failedRule-label">Configured Guidance</div>
          <div className="failedRule-guidance-box">
            &ldquo;
            {failedRuleDetailsLoader
              ? "Loading..."
              : failedRuleDetailsMappingData?.guidance_decision_support
                    ?.configured_guidance
                ? failedRuleDetailsMappingData?.guidance_decision_support
                    ?.configured_guidance
                : "-"}
            &rdquo;
          </div>

          <div className="failedRule-label failedRule-label--spaced">
            Recommended Action
          </div>
          <div className="failedRule-value">
            {failedRuleDetailsLoader
              ? "Loading..."
              : failedRuleDetailsMappingData?.guidance_decision_support
                    ?.recommended_action
                ? failedRuleDetailsMappingData?.guidance_decision_support
                    ?.recommended_action
                : "-"}
          </div>
        </div>
      </section>

      {/* Test Result / Failure Reason */}
      <section className="failedRule-card failedRule-card--failure">
        <div className="failedRule-card-body">
          <div className="failedRule-grid failedRule-grid--tight">
            <div className="failedRule-field">
              <div className="failedRule-label">Test Status</div>
              <div className="failedRule-value failedRule-value--failed">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : failedRuleDetailsMappingData?.testing_information
                        ?.test_status
                    ? failedRuleDetailsMappingData?.testing_information
                        ?.test_status
                    : "-"}
              </div>
            </div>
            <div className="failedRule-field">
              <div className="failedRule-label">Tested By</div>
              <div className="failedRule-value">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : failedRuleDetailsMappingData?.testing_information?.tested_by
                    ? failedRuleDetailsMappingData?.testing_information
                        ?.tested_by
                    : "-"}
              </div>
            </div>

            <div className="failedRule-field">
              <div className="failedRule-label">Tested On</div>
              <div className="failedRule-value">
                {failedRuleDetailsLoader
                  ? "Loading..."
                  : failedRuleDetailsMappingData?.testing_information?.tested_on
                    ? failedRuleDetailsMappingData?.testing_information
                        ?.tested_on
                    : "-"}
              </div>
            </div>
          </div>

          <div className="failedRule-divider" />

          <div className="failedRule-field">
            <div className="failedRule-label">Failure Reason</div>
            <div className="failedRule-value failedRule-value--italic">
              &ldquo;
              {failedRuleDetailsLoader
                ? "Loading..."
                : failedRuleDetailsMappingData?.failure_information?.reason
                  ? failedRuleDetailsMappingData?.failure_information?.reason
                  : "-"}
              &rdquo;
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <div className="failedRule-footer">
        <button
          type="button"
          className="failedRule-btn failedRule-btn--primary"
          onClick={handleBack}
        >
          Back to Test Rules
        </button>
      </div>
    </div>
  );
}
